<template>
  <a-modal
    :visible="activityVisible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #title>
        <a-input
          v-decorator="[
            'title',
            {
              rules: [
                {
                  required: true,
                  message: '请输入标题',
                },
              ],
            },
          ]"
          placeholder="请输入标题"
        />
      </template>
      <template #title_sub>
        <a-input
          v-decorator="[
            'title_sub',
            {
              rules: [
                {
                  required: true,
                  message: '请输入副标题',
                },
              ],
            },
          ]"
          placeholder="请输入副标题"
        />
      </template>
      <template #pdf_doc_info>
        <a-upload
          v-decorator="[
            'pdf_doc_info',
            { rules: [{ required: true, message: '请选择附件' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".pdf"
          :with-credentials="false"
          :data="{fileType:'file',}"
          :action="`${uploadUrl}system/upload`"
          :before-upload="beforeUpload"
        >
          <a-button> <a-icon type="upload" /> 点击上传 </a-button>
        </a-upload>
      </template>
      <template #sort>
        <a-input-number
          v-decorator="[
            'sort',
            { rules: [{ required: true, message: '请输入排序' }] },
          ]"
        />
      </template>
      <template #summary>
        <a-textarea
          v-decorator="[
            'summary',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          rows="3"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
      <template #pdf_params>
        <a-textarea
          v-decorator="[
            'pdf_params',
            { rules: [{ required: false, message: '请输入' }] },
          ]"
          rows="3"
          placeholder="请输入"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
export default {
  props: ['activityVisible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData,
    };
  },
  async mounted() {
  },

  methods: {
    normFile(e) {
      console.log('TCL: normFile -> e', e);

      if(e && e.file.status === 'done'){
        const fileList = [{
          uid: e.file.response.data.id,
          status: 'done',
          name: e.file.response.data.name,
          url: e.file.response.data.url,
        }];
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      console.log('TCL: beforeUpload -> file', file);
      const isJPG = file.type === 'application/pdf';
      if (!isJPG) {
        this.$message.error('请上传pdf格式！');
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('请选择小于10M文件！');
      }
      return isJPG&& isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
